import React from "react";
import "../CSS/Process.css";
import { FaIdCard, FaCheck, FaEdit, FaFileAlt, FaClipboardCheck } from "react-icons/fa";

const steps = [
  {
    icon: <FaIdCard />,
    step: "Step 1",
    title: "Document Submitted",
    text: "Vizatt collection center",
    color: "icon1"
  },
  {
    icon: <FaCheck />,
    step: "Step 2",
    title: "Verify the Document",
    text: "Forward the document for scrutiny",
    color: "icon2"
  },
  {
    icon: <FaEdit />,
    step: "Step 3",
    title: "Verify & Authenticate",
    text: "HOME / HRD / SDM chamber",
    color: "icon3"
  },
  {
    icon: <FaFileAlt />,
    step: "Step 4",
    title: "Submitted to MEA",
    text: "Ministry of External Affairs, New Delhi",
    color: "icon4"
  },
  {
    icon: <FaClipboardCheck />,
    step: "Step 5",
    title: "Embassy / Consulate",
    text: "Document attestation completed",
    color: "icon5"
  }
];

const Process = () => {
  return (
    <section className="process-section">

      <div className="process-header">

        <h2>MEA & Apostille Attestation Process</h2>

        <p>
          Our streamlined document attestation process ensures secure
          verification and authentication through government authorities.
        </p>

      </div>

      <div className="process-container">

        {steps.map((item, index) => (
          <div className="process-card" key={index}>

            <div className={`icon-circle ${item.color}`}>
              {item.icon}
            </div>

            <div className="process-text">
              <span>{item.step}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>

          </div>
        ))}

      </div>

    </section>
  );
};

export default Process;